import {
  BooleanField,
  CreateButton,
  Datagrid,
  FunctionField,
  List,
  NumberField,
  TextField,
  TopToolbar,
  useRecordContext,
} from "react-admin";
import { Box, Chip } from "@mui/material";

type Card = {
  id: string;
  name: string;
  image: string | null;
  cost_rub: number | null;
  exchange_rate: number | null;
  currency: string;
  coming_soon: boolean;
  best_rate: boolean;
  sort_order: number;
  enabled: boolean;
};

const Preview = () => {
  const r = useRecordContext<Card>();
  const v = r?.image || "";
  return (
    <Box
      sx={{
        width: 120,
        aspectRatio: "2.4",
        borderRadius: 1.5,
        overflow: "hidden",
        bgcolor: "action.hover",
        display: "grid",
        placeItems: "center",
        color: "text.disabled",
      }}
    >
      {v ? <img src={v} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : "—"}
    </Box>
  );
};

const Actions = () => (
  <TopToolbar>
    <CreateButton label="Добавить карту" />
  </TopToolbar>
);

export function CardDesignList() {
  return (
    <List actions={<Actions />} perPage={50} sort={{ field: "sort_order", order: "ASC" }} exporter={false}>
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <FunctionField label="Превью" render={() => <Preview />} />
        <TextField source="name" label="Название" />
        <TextField source="currency" label="Валюта" />
        <FunctionField
          label="Стоимость, ₽"
          render={(r: Card) => (r.cost_rub != null ? Number(r.cost_rub).toLocaleString("ru-RU") : "—")}
        />
        <FunctionField
          label="Курс $1"
          render={(r: Card) => (r.exchange_rate != null ? `${Number(r.exchange_rate)} ₽` : "—")}
        />
        <FunctionField
          label="Статус"
          render={(r: Card) =>
            r.coming_soon ? <Chip size="small" label="Скоро" /> : <Chip size="small" color="success" label="Доступна" />
          }
        />
        <NumberField source="sort_order" label="Порядок" />
        <BooleanField source="enabled" label="В каталоге" />
      </Datagrid>
    </List>
  );
}
